const messages = {
  es: {
    translations: {
      signup: {
        title: "Registro",
        toasts: {
          success:
            "¡El usuario ha sido creado satisfactoriamente! ¡Ahora inicia sesión!",
          fail: "Error creando el usuario. Verifica la data reportada.",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
        },
        buttons: {
          submit: "Regístrate",
          login: "¿Ya tienes una cuenta? ¡Inicia sesión!",
        },
      },
      login: {
        title: "Inicio de Sesión",
        form: {
          email: "Correo Electrónico",
          password: "Contraseña",
        },
        buttons: {
          submit: "Ingresa",
          register: "¿No tienes cuenta? ¡Regístrate!",
        },
      },
      auth: {
        toasts: {
          success: "¡Inicio de sesión exitoso!",
        },
      },
      dashboard: {
        period: {
          from: "Desde",
          to: "Hasta",
          today: "Hoy",
          last7: "7 días",
          last30: "30 días"
        },
        cards: {
          inAttendance: "En servicio",
          waiting: "Esperando atención",
          onlineUsers: "Agentes en línea",
          closed: "Atenciones finalizadas",
          messagesSent: "Mensajes enviados",
          messagesReceived: "Mensajes recibidos",
          newLeads: "Nuevos leads",
          avgAttendance: "Tiempo medio de atención",
          avgWait: "Tiempo medio de espera"
        },
        attendants: {
          title: "Agentes",
          name: "Nombre",
          closed: "Atenciones concluidas",
          avg: "T.M. atención",
          status: "Estado (actual)",
          online: "En línea",
          offline: "Desconectado"
        },
        charts: {
          perDay: {
            title: "Tickets hoy: ",
          },
        },
        messages: {
          inAttendance: {
            title: "En servicio"
          },
          waiting: {
            title: "Esperando"
          },
          closed: {
            title: "Finalizado"
          }
        }
      },
      connections: {
        title: "Conexiones",
        toasts: {
          deleted:
            "¡La conexión de WhatsApp ha sido borrada satisfactoriamente!",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteMessage: "¿Estás seguro? Este proceso no puede ser revertido.",
          disconnectTitle: "Desconectar",
          disconnectMessage: "Estás seguro? Deberá volver a leer el código QR",
        },
        buttons: {
          add: "Agrega WhatsApp",
          disconnect: "Desconectar",
          tryAgain: "Inténtalo de nuevo",
          qrcode: "QR CODE",
          newQr: "Nuevo QR CODE",
          connecting: "Conectando",
        },
        toolTips: {
          disconnected: {
            title: "No se pudo iniciar la sesión de WhatsApp",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y vuelva a intentarlo o solicite un nuevo código QR",
          },
          qrcode: {
            title: "Esperando la lectura del código QR",
            content:
              "Haga clic en el botón 'CÓDIGO QR' y lea el Código QR con su teléfono celular para iniciar la sesión",
          },
          connected: {
            title: "Conexión establecida",
          },
          timeout: {
            title: "Se perdió la conexión con el teléfono celular",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y que WhatsApp esté abierto, o haga clic en el botón 'Desconectar' para obtener un nuevo código QR",
          },
        },
        table: {
          name: "Nombre",
          status: "Estado",
          lastUpdate: "Última Actualización",
          default: "Por Defecto",
          actions: "Acciones",
          session: "Sesión",
        },
      },
      whatsappModal: {
        title: {
          add: "Agrega WhatsApp",
          edit: "Edita WhatsApp",
        },
        form: {
          name: "Nombre",
          default: "Por Defecto",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "WhatsApp guardado satisfactoriamente.",
      },
      qrCode: {
        message: "Lée el código QR para empezar la sesión.",
      },
      contacts: {
        title: "Contactos",
        toasts: {
          deleted: "¡Contacto borrado satisfactoriamente!",
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Borrar",
          importTitlte: "Importar contactos",
          deleteMessage:
            "¿Estás seguro que deseas borrar este contacto? Todos los tickets relacionados se perderán.",
          importMessage:
            "¿Quieres importar todos los contactos desde tu teléfono?",
        },
        buttons: {
          import: "Importar Contactos",
          add: "Agregar Contacto",
        },
        table: {
          name: "Nombre",
          whatsapp: "WhatsApp",
          email: "Correo Electrónico",
          actions: "Acciones",
        },
      },
      contactModal: {
        title: {
          add: "Agregar contacto",
          edit: "Editar contacto",
        },
        form: {
          mainInfo: "Detalles del contacto",
          extraInfo: "Información adicional",
          name: "Nombre",
          number: "Número de Whatsapp",
          email: "Correo Electrónico",
          extraName: "Nombre del Campo",
          extraValue: "Valor",
        },
        buttons: {
          addExtraInfo: "Agregar información",
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Contacto guardado satisfactoriamente.",
      },
      quickAnswersModal: {
        title: {
          add: "Agregar respuesta rápida",
          edit: "Editar respuesta rápida",
        },
        form: {
          shortcut: "Atajo",
          message: "Respuesta rápida",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Respuesta rápida guardada correctamente.",
      },
      queueModal: {
        title: {
          add: "Agregar cola",
          edit: "Editar cola",
        },
        form: {
          name: "Nombre",
          color: "Color",
          greetingMessage: "Mensaje de saludo",
        },
        buttons: {
          okAdd: "Añadir",
          okEdit: "Ahorrar",
          cancel: "Cancelar",
        },
      },
      userModal: {
        title: {
          add: "Agregar usuario",
          edit: "Editar usuario",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
          profile: "Perfil",
          whatsapp: "Conexión estándar",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Usuario guardado satisfactoriamente.",
      },
      chat: {
        noTicketMessage: "Selecciona un ticket para empezar a chatear.",
      },
      ticketsManager: {
        buttons: {
          newTicket: "Nuevo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Linhas",
      },
      tickets: {
        toasts: {
          deleted: "El ticket en el que estabas ha sido borrado.",
        },
        notification: {
          message: "Mensaje de",
        },
        tabs: {
          open: { title: "Bandeja" },
          closed: { title: "Resueltos" },
          search: { title: "Buscar" },
        },
        search: {
          placeholder: "Buscar tickets y mensajes.",
        },
        buttons: {
          showAll: "Todos",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Escriba para buscar usuarios",
        fieldQueueLabel: "Transferir a la cola",
        fieldConnectionLabel: "Transferir to conexión",
        fieldQueuePlaceholder: "Seleccione una cola",
        fieldConnectionPlaceholder: "Seleccione una conexión",
        noOptions: "No se encontraron usuarios con ese nombre",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        pendingHeader: "Cola",
        assignedHeader: "Trabajando en",
        noTicketsTitle: "¡Nada acá!",
        connectionTitle: "Conexión que se está utilizando actualmente.",
        noTicketsMessage:
          "No se encontraron tickets con este estado o término de búsqueda",
        buttons: {
          accept: "Acceptar",
        },
      },
      newTicketModal: {
        title: "Crear Ticket",
        fieldLabel: "Escribe para buscar un contacto",
        add: "Añadir",
        buttons: {
          ok: "Guardar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          kanban: "Kanban",
          tags: "Etiquetas",
          schedules: "Programaciones",
          tasks: "Tareas",
          calendar: "Calendario",
          internalChat: "Chat Interno",
          campaigns: "Campañas",
          announcements: "Informativos",
          system: "Sistema",
          companies: "Empresas",
          plans: "Planes",
          connections: "Conexiones",
          tickets: "Atenciones",
          contacts: "Contactos",
          quickAnswers: "Respuestas rápidas",
          queues: "Colas & Chatbot",
          administration: "Administración",
          users: "Usuarios",
          settings: "Configuración",
        },
        appBar: {
          greeting: "Hola {{name}}, ¡bienvenido a {{company}}!",
          user: {
            profile: "Perfil",
            logout: "Cerrar Sesión",
          },
          darkMode: "Modo oscuro",
        },
      },
      notifications: {
        noTickets: "Sin notificaciones.",
      },
      tags: {
        title: "Etiquetas",
        buttons: {
          add: "Agregar etiqueta"
        },
        table: {
          name: "Nombre",
          color: "Color",
          kanban: "Columna en Kanban",
          position: "Orden",
          actions: "Acciones",
          yes: "Sí",
          no: "No"
        },
        confirmationModal: {
          deleteTitle: "Eliminar la etiqueta",
          deleteMessage: "La etiqueta se quitará de todas las atenciones. Esta acción no se puede deshacer."
        },
        toasts: {
          deleted: "Etiqueta eliminada.",
          saved: "Etiqueta guardada."
        }
      },
      tagModal: {
        title: {
          add: "Nueva etiqueta",
          edit: "Editar etiqueta"
        },
        form: {
          name: "Nombre",
          color: "Color",
          kanban: "Mostrar como columna en Kanban",
          position: "Orden de la columna"
        },
        buttons: {
          cancel: "Cancelar",
          ok: "Guardar"
        }
      },
      ticketTags: {
        placeholder: "Agregar etiquetas",
        noOptions: "Ninguna etiqueta registrada"
      },
      kanban: {
        title: "Kanban",
        open: "Abiertos",
        empty: "Ninguna atención",
        pending: "Esperando",
        noLanes: "Ninguna etiqueta está marcada como columna del Kanban. Créela en Administración > Etiquetas.",
        unassigned: "Sin agente"
      },
      schedules: {
        title: "Programaciones",
        loadMore: "Cargar más",
        buttons: {
          add: "Nueva programación"
        },
        filters: {
          pending: "Pendientes",
          sent: "Enviados",
          error: "Con error",
          all: "Todos",
          search: "Buscar contacto o mensaje"
        },
        table: {
          contact: "Contacto",
          body: "Mensaje",
          sendAt: "Envío",
          status: "Estado",
          user: "Creado por",
          actions: "Acciones"
        },
        status: {
          pending: "Pendiente",
          sending: "Enviando",
          sent: "Enviado",
          error: "Error"
        },
        confirmationModal: {
          deleteTitle: "Eliminar programación",
          deleteMessage: "El mensaje no será enviado. Esta acción no se puede deshacer."
        },
        toasts: {
          saved: "Programación guardada.",
          deleted: "Programación eliminada."
        },
        empty: "Ninguna programación encontrada."
      },
      scheduleModal: {
        title: {
          add: "Programar mensaje",
          edit: "Editar programación"
        },
        form: {
          contact: "Contacto",
          body: "Mensaje",
          bodyHelp: "Use {{name}} para insertar el nombre del contacto.",
          sendAt: "Fecha y hora de envío"
        },
        buttons: {
          cancel: "Cancelar",
          ok: "Programar",
          okEdit: "Guardar"
        }
      },
      tasks: {
        title: "Tareas",
        buttons: {
          add: "Nueva tarea"
        },
        filters: {
          mine: "Mías",
          open: "Abiertas",
          overdue: "Atrasadas",
          done: "Concluidas",
          all: "Todas",
          search: "Buscar tarea o contacto"
        },
        table: {
          title: "Tarea",
          dueAt: "Plazo",
          priority: "Prioridad",
          assignedUser: "Responsable",
          contact: "Contacto",
          actions: "Acciones"
        },
        priority: {
          low: "Baja",
          normal: "Normal",
          high: "Alta"
        },
        noDue: "Sin plazo",
        overdue: "Atrasada",
        complete: "Concluir",
        reopen: "Reabrir",
        confirmationModal: {
          deleteTitle: "Eliminar tarea",
          deleteMessage: "Esta acción no se puede deshacer."
        },
        toasts: {
          saved: "Tarea guardada.",
          deleted: "Tarea eliminada.",
          assigned: "Nueva tarea para usted: {{title}}"
        },
        empty: "Ninguna tarea encontrada.",
        loadMore: "Cargar más"
      },
      taskModal: {
        title: {
          add: "Nueva tarea",
          edit: "Editar tarea"
        },
        form: {
          title: "Título",
          description: "Descripción",
          dueAt: "Plazo",
          priority: "Prioridad",
          assignedUser: "Responsable",
          contact: "Contacto (opcional)",
          done: "Concluida"
        },
        buttons: {
          cancel: "Cancelar",
          ok: "Guardar",
          delete: "Eliminar"
        }
      },
      calendar: {
        title: "Calendario",
        today: "Hoy",
        newTask: "Nueva tarea",
        newSchedule: "Nueva programación",
        legend: {
          task: "Tarea",
          taskDone: "Tarea concluida",
          schedule: "Programación",
          scheduleSent: "Programación enviada",
          error: "Atrasada / con error"
        },
        noEvents: "Nada para este día.",
        more: "+{{count}} más",
        weekdays: "Dom,Lun,Mar,Mié,Jue,Vie,Sáb"
      },
      internalChat: {
        title: "Chat Interno",
        newChat: "Nueva conversación",
        noChats: "Aún no hay conversaciones. Empiece una con un compañero.",
        selectChat: "Seleccione una conversación o empiece una nueva.",
        placeholder: "Escriba un mensaje (Enter envía, Shift+Enter nueva línea)",
        send: "Enviar",
        loadOlder: "Cargar mensajes anteriores",
        you: "Usted",
        members: "{{count}} participantes",
        editGroup: "Editar grupo",
        leave: "Salir de la conversación",
        deleteGroup: "Eliminar grupo",
        confirmLeave: "Dejará de ver esta conversación.",
        confirmDelete: "El grupo y todos los mensajes se eliminarán para todos.",
        newMessage: "{{name}}: {{body}}",
        modal: {
          titleNew: "Nueva conversación",
          titleEdit: "Editar grupo",
          users: "Participantes",
          groupTitle: "Nombre del grupo",
          groupHelp: "Obligatorio cuando hay más de un participante.",
          cancel: "Cancelar",
          create: "Empezar",
          save: "Guardar"
        }
      },
      campaigns: {
        title: "Campañas",
        buttons: {
          add: "Nueva campaña"
        },
        empty: "Aún no hay campañas.",
        table: {
          name: "Campaña",
          status: "Estado",
          progress: "Progreso",
          when: "Inicio",
          actions: "Acciones"
        },
        status: {
          draft: "Borrador",
          scheduled: "Programada",
          running: "Enviando",
          paused: "Pausada",
          finished: "Concluida",
          canceled: "Cancelada"
        },
        actions: {
          edit: "Editar",
          start: "Iniciar",
          pause: "Pausar",
          resume: "Reanudar",
          cancel: "Cancelar",
          report: "Informe",
          delete: "Eliminar"
        },
        progress: "{{done}} de {{total}}",
        notStarted: "No iniciada",
        confirm: {
          startTitle: "¿Iniciar la campaña?",
          startMessage: "Los mensajes saldrán respetando el intervalo, el horario y el límite diario configurados.",
          cancelTitle: "¿Cancelar la campaña?",
          cancelMessage: "Los envíos pendientes se descartarán. No se puede deshacer.",
          deleteTitle: "¿Eliminar la campaña?",
          deleteMessage: "La campaña y su informe de envíos se eliminarán."
        },
        toasts: {
          saved: "Campaña guardada.",
          deleted: "Campaña eliminada."
        }
      },
      campaignModal: {
        title: {
          add: "Nueva campaña",
          edit: "Editar campaña"
        },
        warning: "El envío masivo por WhatsApp no oficial puede provocar el bloqueo del número. Use intervalos largos, pocos mensajes por día y solo para quien ya conversa con usted.",
        form: {
          name: "Nombre de la campaña",
          message: "Mensaje {{n}}",
          messageHelp: "Use {{name}} para el nombre del contacto. Cada envío sortea una de las variaciones.",
          addVariation: "Agregar variación",
          removeVariation: "Quitar",
          target: "Destinatarios",
          targetAll: "Todos los que ya conversaron con usted",
          targetTags: "Contactos con atenciones en estas etiquetas",
          targetContacts: "Contactos elegidos",
          tags: "Etiquetas",
          contacts: "Contactos",
          eligible: "{{count}} contacto(s) recibirán esta campaña",
          eligibleHelp: "Solo entran contactos que ya le enviaron mensajes.",
          scheduledAt: "Empezar el (opcional)",
          scheduledHelp: "Vacío: empieza al hacer clic en Iniciar.",
          minDelay: "Intervalo mínimo (s)",
          maxDelay: "Intervalo máximo (s)",
          dailyLimit: "Límite por día",
          hourStart: "Enviar desde (h)",
          hourEnd: "Hasta (h)",
          safety: "Seguridad del envío"
        },
        buttons: {
          cancel: "Cancelar",
          ok: "Guardar"
        }
      },
      campaignReport: {
        title: "Informe: {{name}}",
        total: "Total",
        filters: {
          all: "Todos",
          pending: "Pendientes",
          sent: "Enviados",
          error: "Con error",
          skipped: "Ignorados"
        },
        table: {
          contact: "Contacto",
          status: "Estado",
          sentAt: "Enviado el",
          detail: "Mensaje / error"
        },
        status: {
          pending: "Pendiente",
          sent: "Enviado",
          error: "Error",
          skipped: "Ignorado"
        },
        close: "Cerrar",
        loadMore: "Cargar más"
      },
      announcements: {
        title: "Informativos",
        buttons: {
          add: "Nuevo informativo"
        },
        empty: "Ningún informativo por ahora.",
        priority: {
          low: "Baja",
          normal: "Normal",
          high: "Alta"
        },
        inactive: "Inactivo",
        by: "por {{name}} el {{date}}",
        newToast: "Nuevo informativo: {{title}}",
        confirmDelete: "¿Eliminar este informativo?",
        toasts: {
          saved: "Informativo guardado.",
          deleted: "Informativo eliminado."
        }
      },
      announcementModal: {
        title: {
          add: "Nuevo informativo",
          edit: "Editar informativo"
        },
        form: {
          title: "Título",
          text: "Texto",
          priority: "Prioridad",
          active: "Activo (visible para el equipo)"
        },
        buttons: {
          cancel: "Cancelar",
          ok: "Guardar"
        }
      },
      companies: {
        title: "Empresas",
        buttons: {
          add: "Nueva empresa"
        },
        table: {
          name: "Empresa",
          plan: "Plan",
          usage: "Uso",
          dueDate: "Vencimiento",
          status: "Estado",
          actions: "Acciones"
        },
        usage: "{{users}} usuario(s) · {{connections}} conexión(es)",
        active: "Activa",
        inactive: "Inactiva",
        noPlan: "Sin plan",
        overdue: "Vencida",
        actions: {
          edit: "Editar",
          activate: "Activar",
          deactivate: "Desactivar",
          delete: "Eliminar"
        },
        confirmDeactivate: "¿Desactivar la empresa {{name}}? Nadie de ella podrá entrar hasta que sea reactivada.",
        confirmDelete: "¿Eliminar DEFINITIVAMENTE la empresa {{name}} y todos sus datos (contactos, atenciones, mensajes, usuarios)? Esta acción no se puede deshacer.",
        toasts: {
          saved: "Empresa guardada.",
          deleted: "Empresa eliminada."
        }
      },
      companyModal: {
        title: {
          add: "Nueva empresa",
          edit: "Editar empresa"
        },
        form: {
          name: "Nombre de la empresa",
          plan: "Plan",
          dueDate: "Vencimiento",
          email: "E-mail",
          phone: "Teléfono",
          document: "Documento",
          active: "Activa",
          admin: "Administrador de la empresa",
          adminName: "Nombre",
          adminEmail: "E-mail de acceso",
          adminPassword: "Contraseña inicial"
        },
        buttons: {
          cancel: "Cancelar",
          ok: "Guardar"
        }
      },
      plans: {
        title: "Planes",
        buttons: {
          add: "Nuevo plan"
        },
        table: {
          name: "Plan",
          users: "Usuarios",
          connections: "Conexiones",
          queues: "Colas",
          campaigns: "Campañas",
          actions: "Acciones"
        },
        yes: "Sí",
        no: "No",
        confirmDelete: "¿Eliminar el plan {{name}}?",
        toasts: {
          saved: "Plan guardado.",
          deleted: "Plan eliminado."
        }
      },
      planModal: {
        title: {
          add: "Nuevo plan",
          edit: "Editar plan"
        },
        form: {
          name: "Nombre",
          maxUsers: "Máx. usuarios",
          maxConnections: "Máx. conexiones",
          maxQueues: "Máx. colas",
          useCampaigns: "Permite campañas"
        },
        buttons: {
          cancel: "Cancelar",
          ok: "Guardar"
        }
      },
      dueBanner: {
        soon: "La suscripción de {{company}} vence en {{days}} día(s) ({{date}}).",
        today: "La suscripción de {{company}} vence hoy.",
        overdue: "La suscripción de {{company}} está vencida desde {{date}}. Regularice para evitar el bloqueo."
      },
      queues: {
        title: "Linhas",
        table: {
          name: "Nombre",
          color: "Color",
          greeting: "Mensaje de saludo",
          actions: "Comportamiento",
        },
        buttons: {
          add: "Agregar cola",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "¿Estás seguro? ¡Esta acción no se puede revertir! Los tickets en esa cola seguirán existiendo, pero ya no tendrán ninguna cola asignada.",
        },
      },
      queueSelect: {
        inputLabel: "Linhas",
      },
      quickAnswers: {
        title: "Respuestas rápidas",
        table: {
          shortcut: "Atajo",
          message: "Respuesta rápida",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar respuesta rápida",
        },
        toasts: {
          deleted: "Respuesta rápida eliminada correctamente",
        },
        searchPlaceholder: "Buscar ...",
        confirmationModal: {
          deleteTitle:
            "¿Está seguro de que desea eliminar esta respuesta rápida?",
          deleteMessage: "Esta acción no se puede deshacer.",
        },
      },
      users: {
        title: "Usuarios",
        table: {
          name: "Nombre",
          email: "Correo Electrónico",
          profile: "Perfil",
          whatsapp: "Conexión estándar",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar usuario",
        },
        toasts: {
          deleted: "Usuario borrado satisfactoriamente.",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteMessage:
            "Toda la información del usuario se perderá. Los tickets abiertos de los usuarios se moverán a la cola.",
        },
      },
      settings: {
        success: "Configuración guardada satisfactoriamente.",
        title: "Configuración",
        settings: {
          userCreation: {
            name: "Creación de usuarios",
            options: {
              enabled: "Habilitado",
              disabled: "Deshabilitado",
            },
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Asignado a:",
          buttons: {
            return: "Devolver",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceptar",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Escriba un mensaje o presione '' / '' para usar las respuestas rápidas registradas",
        placeholderClosed:
          "Vuelva a abrir o acepte este ticket para enviar un mensaje.",
        signMessage: "Firmar",
      },
      contactDrawer: {
        header: "Detalles del contacto",
        buttons: {
          edit: "Editar contacto",
        },
        extraInfo: "Otra información",
      },
      ticketOptionsMenu: {
        schedule: "Programar mensaje",
        delete: "Borrar",
        transfer: "Transferir",
        confirmationModal: {
          title: "¿Borrar ticket #",
          titleFrom: "del contacto ",
          message:
            "¡Atención! Todos los mensajes Todos los mensajes relacionados con el ticket se perderán.",
        },
        buttons: {
          delete: "Borrar",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        delete: "Borrar",
        reply: "Responder",
        confirmationModal: {
          title: "¿Borrar mensaje?",
          message: "Esta acción no puede ser revertida.",
        },
      },
      backendErrors: {
        ERR_COMPANY_INACTIVE: "Empresa desactivada. Contacte al soporte.",
        ERR_COMPANY_NOT_FOUND: "Empresa no encontrada.",
        ERR_COMPANY_INVALID_NAME: "Informe el nombre de la empresa (mínimo 2 caracteres).",
        ERR_COMPANY_INVALID_DATE: "Fecha de vencimiento inválida.",
        ERR_COMPANY_ADMIN_REQUIRED: "Informe nombre, e-mail y contraseña del administrador de la empresa.",
        ERR_COMPANY_OWN: "No puede desactivar ni eliminar su propia empresa.",
        ERR_COMPANY_STILL_ACTIVE: "Desactive la empresa antes de eliminarla.",
        ERR_PLAN_NOT_FOUND: "Plan no encontrado.",
        ERR_PLAN_INVALID_NAME: "Informe el nombre del plan.",
        ERR_PLAN_INVALID_LIMIT: "Los límites deben ser números enteros entre 0 y 9999.",
        ERR_PLAN_NAME_ALREADY_EXISTS: "Ya existe un plan con ese nombre.",
        ERR_PLAN_IN_USE: "Este plan está en uso por alguna empresa.",
        ERR_PLAN_LIMIT_USERS: "Se alcanzó el límite de usuarios del plan.",
        ERR_PLAN_LIMIT_CONNECTIONS: "Se alcanzó el límite de conexiones del plan.",
        ERR_PLAN_LIMIT_QUEUES: "Se alcanzó el límite de colas del plan.",
        ERR_PLAN_NO_CAMPAIGNS: "El plan de la empresa no incluye campañas.",
        ERR_CAMPAIGN_NOT_FOUND: "Campaña no encontrada.",
        ERR_CAMPAIGN_INVALID_NAME: "Dé un nombre a la campaña (2 a 120 caracteres).",
        ERR_CAMPAIGN_INVALID_MESSAGES: "Escriba de 1 a 3 mensajes (hasta 4096 caracteres cada uno).",
        ERR_CAMPAIGN_INVALID_TARGET: "Destinatarios inválidos.",
        ERR_CAMPAIGN_INVALID_DATE: "Fecha de inicio inválida.",
        ERR_CAMPAIGN_INVALID_DELAY: "Intervalo inválido: mínimo de 20 segundos y el máximo no puede ser menor que el mínimo.",
        ERR_CAMPAIGN_INVALID_LIMIT: "El límite diario debe estar entre 1 y 1000.",
        ERR_CAMPAIGN_INVALID_HOURS: "Horario inválido: el fin debe ser después del inicio.",
        ERR_CAMPAIGN_NOT_EDITABLE: "Solo se pueden editar campañas en borrador o programadas.",
        ERR_CAMPAIGN_RUNNING: "Pause o cancele la campaña antes de eliminarla.",
        ERR_CAMPAIGN_INVALID_ACTION: "Esta acción no es posible en el estado actual de la campaña.",
        ERR_CAMPAIGN_NO_RECIPIENTS: "Ningún contacto elegible para esta campaña.",
        ERR_ANNOUNCEMENT_NOT_FOUND: "Informativo no encontrado.",
        ERR_ANNOUNCEMENT_INVALID_TITLE: "El título debe tener entre 2 y 150 caracteres.",
        ERR_ANNOUNCEMENT_INVALID_TEXT: "Escriba el texto del informativo.",
        ERR_ANNOUNCEMENT_INVALID_PRIORITY: "Prioridad inválida.",
        ERR_CHAT_NOT_FOUND: "Conversación no encontrada.",
        ERR_CHAT_INVALID_USERS: "Elija al menos un participante válido.",
        ERR_CHAT_INVALID_TITLE: "Dé un nombre al grupo (mínimo 2 caracteres).",
        ERR_CHAT_INVALID_BODY: "Mensaje vacío o demasiado largo.",
        ERR_TASK_NOT_FOUND: "Tarea no encontrada.",
        ERR_TASK_INVALID_TITLE: "El título debe tener entre 2 y 200 caracteres.",
        ERR_TASK_INVALID_DATE: "Plazo inválido.",
        ERR_TASK_INVALID_PRIORITY: "Prioridad inválida.",
        ERR_TASK_INVALID_STATUS: "Estado inválido.",
        ERR_TASK_INVALID_USER: "Responsable inválido.",
        ERR_TASK_INVALID_CONTACT: "Contacto inválido.",
        ERR_SCHEDULE_NOT_FOUND: "Programación no encontrada.",
        ERR_SCHEDULE_INVALID_BODY: "Escriba el mensaje (hasta 4096 caracteres).",
        ERR_SCHEDULE_INVALID_CONTACT: "Elija un contacto válido (no se aceptan grupos).",
        ERR_SCHEDULE_INVALID_DATE: "Elija una fecha y hora futura.",
        ERR_SCHEDULE_ALREADY_SENT: "Esta programación ya fue enviada y no se puede cambiar.",
        ERR_TAG_INVALID_NAME: "Nombre de etiqueta inválido (mínimo 2 caracteres).",
        ERR_TAG_NAME_ALREADY_EXISTS: "Ya existe una etiqueta con ese nombre.",
        ERR_TAG_INVALID_COLOR: "Color inválido.",
        ERR_TAG_NOT_FOUND: "Etiqueta no encontrada.",
        ERR_NO_OTHER_WHATSAPP:
          "Debe haber al menos una conexión de WhatsApp predeterminada.",
        ERR_NO_DEF_WAPP_FOUND:
          "No se encontró WhatsApp predeterminado. Verifique la página de conexiones.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sesión de WhatsApp no ​​está inicializada. Verifique la página de conexiones.",
        ERR_WAPP_CHECK_CONTACT:
          "No se pudo verificar el contacto de WhatsApp. Verifique la página de conexiones.",
        ERR_WAPP_INVALID_CONTACT: "Este no es un número de whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "No se pudieron descargar los medios de WhatsApp. Verifique la página de conexiones.",
        ERR_INVALID_CREDENTIALS: "Error de autenticación. Vuelva a intentarlo.",
        ERR_SENDING_WAPP_MSG:
          "Error al enviar el mensaje de WhatsApp. Verifique la página de conexiones.",
        ERR_DELETE_WAPP_MSG: "No se pudo borrar el mensaje de WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Ya hay un ticket abierto para este contacto.",
        ERR_SESSION_EXPIRED: "Sesión caducada. Inicie sesión.",
        ERR_USER_CREATION_DISABLED:
          "La creación de usuarios fue deshabilitada por el administrador.",
        ERR_NO_PERMISSION: "No tienes permiso para acceder a este recurso.",
        ERR_DUPLICATED_CONTACT: "Ya existe un contacto con este número.",
        ERR_NO_SETTING_FOUND:
          "No se encontró ninguna configuración con este ID.",
        ERR_NO_CONTACT_FOUND: "No se encontró ningún contacto con este ID.",
        ERR_NO_TICKET_FOUND: "No se encontró ningún ticket con este ID.",
        ERR_NO_USER_FOUND: "No se encontró ningún usuario con este ID.",
        ERR_NO_WAPP_FOUND: "No se encontró WhatsApp con este ID.",
        ERR_CREATING_MESSAGE: "Error al crear el mensaje en la base de datos.",
        ERR_CREATING_TICKET: "Error al crear el ticket en la base de datos.",
        ERR_FETCH_WAPP_MSG:
          "Error al obtener el mensaje en WhtasApp, tal vez sea demasiado antiguo.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Este color ya está en uso, elija otro.",
        ERR_WAPP_GREETING_REQUIRED:
          "El mensaje de saludo es obligatorio cuando hay más de una cola.",
      },
    },
  },
};

export { messages };
